import { createSelector } from '@ngrx/store';

import { SearchBarState } from '@shared/base-search-bar/store/state/search-bar.state';
import { searchBarSelector } from '@shared/base-search-bar/store/selectors/search-bar.selector';
import { passengerArrangementAdapter } from '@shared/base-search-bar/store/reducers/passenger-arrangement.reducer';

const { selectAll } = passengerArrangementAdapter.getSelectors();

const getPassengerArrangementState = createSelector(
  searchBarSelector,
  (state: SearchBarState) => state ? state.passengerArrangement : []
);

export const selectPassengerArrangement = createSelector(getPassengerArrangementState, selectAll);
